import { render, staticRenderFns } from "./VisaApproveModal.vue?vue&type=template&id=315af81d&"
import script from "./VisaApproveModal.vue?vue&type=script&lang=js&"
export * from "./VisaApproveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports